import React from 'react';

const GoogleMapLink = ({ children }) => {
    // const address = "76-200 Słupsk, Władysława Jagiełły 3";
    const address = "Władysława Jagiełły 3, Słupsk, Poland"
    const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

    return (
        <a href={mapLink} target="_blank" rel="noopener noreferrer">
            {children}
        </a>
    );
};

export default GoogleMapLink;
